import { render, staticRenderFns } from "./extractCode.vue?vue&type=template&id=226eed6c&scoped=true&"
import script from "./extractCode.vue?vue&type=script&lang=js&"
export * from "./extractCode.vue?vue&type=script&lang=js&"
import style0 from "./extractCode.vue?vue&type=style&index=0&id=226eed6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226eed6c",
  null
  
)

export default component.exports